// Add your custom JS here.

(function ($) {
    function checkHeight(ele) {
        var h = 0;
        $(ele).each(function () {
            if ($(this).height() > h) {
                h = $(this).height();
            }
        });
        $(ele).css('height', h + 'px');
    }

    function setFullHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', setFullHeight);
    setFullHeight();

    $(document).ready(function () {

        $(window).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                $('.toTop').addClass('active');
            } else {
                $('.toTop').removeClass('active');
            }
        });

        $('.toTop').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 'swing');
        });

        $('.menu-item-has-children').append('<button type="button" class="btnSub"><i class="far fa-angle-down"></i></button>');

        $(document).on('click', '.btnSub', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').siblings('.subMenu').slideToggle(300);
        });

        $(document).on('click', '.openMenu', function (e) {
            e.preventDefault();
            $('body').addClass('activeMenu');
        });

        $(document).on('click', '.closeMenu', function (e) {
            e.preventDefault();
            $('body').removeClass('activeMenu');
        });

        if ($('.heroSlider').length) {
            const heroSlider = new Swiper('.heroSlider', {
                navigation: false,
                pagination: false,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                speed: 800,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                on: {
                    /**
                     * Sự kiện này sẽ kích hoạt ngay sau khi
                     * hiệu ứng chuyển slide kết thúc.
                     */
                    slideChangeTransitionEnd: function () {
                        // 'this' ở đây chính là Swiper instance (heroSlider)
                        const swiper = this;

                        // 1. Tạm dừng TẤT CẢ video trong slider
                        // Chúng ta tìm mọi thẻ <video> bên trong slider
                        $(swiper.el).find('video').each(function () {
                            // Dùng 'this' của jQuery để truy cập DOM element
                            if (!this.paused) {
                                this.pause();
                                this.currentTime = 0; // Tua video về đầu
                            }
                        });

                        // 2. Phát video trong slide HIỆN TẠI (active)
                        // Lấy slide đang active
                        const activeSlide = swiper.slides[swiper.activeIndex];
                        // Tìm thẻ <video> BÊN TRONG slide active đó
                        const activeVideo = $(activeSlide).find('video')[0]; // Lấy DOM element

                        // Nếu slide này có video
                        if (activeVideo) {
                            // Bắt buộc: Tắt tiếng video thì trình duyệt mới cho tự động phát
                            activeVideo.muted = true;
                            // Phát video
                            activeVideo.play().catch(error => {
                                console.warn("Lỗi tự động phát video:", error);
                            });
                        }
                    },
                }
            });
        }

        if ($('.homeProd').length) {
            $('.homeProd').each(function() {
                const $thisSection = $(this);
                const sliderContainer = $thisSection.find('.homeProd__slider');
                const nextButton = $thisSection.find('.swiper-button-next');
                const prevButton = $thisSection.find('.swiper-button-prev');

                const homeProd__slider = new Swiper(sliderContainer[0], {
                    slidesPerView: 5,
                    spaceBetween: 28,
                    pagination: false,
                    navigation: {
                        prevEl: prevButton[0],
                        nextEl: nextButton[0]
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    speed: 800,
                    // Responsive breakpoints
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 8
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 1.3,
                            spaceBetween: 8
                        },
                        // when window width is >= 640px
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 8
                        },
                        // when window width is >= 640px
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 12
                        },
                        // when window width is >= 640px
                        991: {
                            slidesPerView: 4,
                            spaceBetween: 8
                        },
                        1080: {
                            slidesPerView: 5,
                            spaceBetween: 12
                        },
                        1644: {
                            slidesPerView: 5,
                            spaceBetween: 28
                        }
                    }
                });
            });
        }
        if ($('.prodInCate').length) {
            $('.prodInCate').each(function() {
                const $thisSection = $(this);
                const sliderContainer = $thisSection.find('.homeProd__slider');
                const nextButton = $thisSection.find('.swiper-button-next');
                const prevButton = $thisSection.find('.swiper-button-prev');

                const homeProd__slider = new Swiper(sliderContainer[0], {
                    slidesPerView: 4,
                    spaceBetween: 10,
                    pagination: false,
                    navigation: {
                        prevEl: prevButton[0],
                        nextEl: nextButton[0]
                    },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    speed: 800,
                    // Responsive breakpoints
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 8
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 1.3,
                            spaceBetween: 8
                        },
                        // when window width is >= 640px
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 8
                        },
                        // when window width is >= 640px
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 10
                        },
                        // when window width is >= 640px
                        991: {
                            slidesPerView: 3,
                            spaceBetween: 8
                        },
                        1644: {
                            slidesPerView: 4,
                            spaceBetween: 28
                        }
                    }
                });
            });
        }

        if ($('.prodGallery').length) {
            const prodThumbs = new Swiper(".prodGallery__thumbs", {
                spaceBetween: 12,
                slidesPerView: 4,
                watchSlidesProgress: true,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        spaceBetween: 8
                    },
                    // when window width is >= 480px
                    480: {
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    640: {
                        spaceBetween: 8
                    },
                    // when window width is >= 640px
                    768: {
                        spaceBetween: 10
                    },
                    // when window width is >= 640px
                    991: {
                        spaceBetween: 12
                    }
                }
            });
            const prodImages = new Swiper(".prodGallery__images", {
                spaceBetween: 10,
                navigation: {
                    nextEl: ".prodGallery__images .swiper-button-next",
                    prevEl: ".prodGallery__images .swiper-button-prev",
                },
                thumbs: {
                    swiper: prodThumbs,
                },
            });
        }

        $(window).on('scroll load', function () {
            if ($('.figureNumber').length) {
                $('.figureNumber').each(function () {
                    var $this = $(this);
                    var position = $this.offset().top;
                    var scrollPosition = $(window).scrollTop() + $(window).height();
                    // Chạy khi phần tử xuất hiện trong màn hình
                    if (position < scrollPosition) {
                        runCounter($this);
                    }
                });
            }
        });

        function runCounter($element) {
            if (!$element.hasClass("counted")) {
                var numberString = $element.html();
                var cleanedNumberString = numberString.replace(/\./g, '');
                var targetNumber = parseInt(cleanedNumberString, 10);

                if (!isNaN(targetNumber)) {
                    $element.addClass("counted");
                    $({ countNum: 0 }).animate({ countNum: targetNumber }, {
                        duration: 3000,
                        easing: "linear",
                        step: function () {
                            let currentNum = Math.floor(this.countNum);
                            let formattedNum = currentNum.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedNum);
                        },
                        complete: function () {
                            let formattedTarget = targetNumber.toLocaleString('de-DE', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0
                            });
                            $element.text(formattedTarget);
                        }
                    });
                } else {
                    console.error("Lỗi: Không thể chuyển đổi '" + numberString + "' thành số hợp lệ.");
                }
            }
        }

        setTimeout(function () {
            AOS.init({ disable: 'mobile', once: true });

            if ($('[data-fancybox]').length) {
                Fancybox.bind('[data-fancybox]', {
                    Carousel: {
                        Zoomable: {
                            Panzoom: {
                                clickAction: "iterateZoom",
                                maxScale: 2,
                            },
                        },
                    },
                });
            }
        }, 500);

    });

    window.addEventListener('load', () => {
        const marqueeContainer = document.getElementById('myMarquee');
        if (!marqueeContainer) {
            console.error("Marquee container '#myMarquee' not found.");
            return;
        }

        const marqueeWrapper = marqueeContainer.querySelector('.marqueeContainer');
        if (!marqueeWrapper) {
            console.error("Marquee wrapper '.marqueeContainer' not found inside '#myMarquee'.");
            return;
        }

        const originalItems = Array.from(marqueeWrapper.children);
        if (originalItems.length === 0) {
            console.warn("Marquee wrapper has no child elements.");
            return; // No items to animate
        }

        // --- Configuration ---
        const speed = 80; // pixels per second
        const direction = -1; // -1: Left, 1: Right (Current logic best supports -1)
        let pauseOnHover = true;

        // --- Clone items ---
        // Clear existing clones if the script runs again (e.g., in development)
        while (marqueeWrapper.children.length > originalItems.length) {
            marqueeWrapper.removeChild(marqueeWrapper.lastChild);
        }
        // Clone
        originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            // Optional: Add a class or attribute to identify clones for debugging
            // clone.setAttribute('data-clone', 'true');
            marqueeWrapper.appendChild(clone);
        });

        // --- Calculate width and duration based on actual rendered width ---
        // Ensure styles are applied and layout is calculated
        // requestAnimationFrame can help ensure layout is stable before measuring
        requestAnimationFrame(() => {
            // Measure the total width of the wrapper containing original + clones
            const totalWidth = marqueeWrapper.scrollWidth;

            // The width needed for one cycle is half of the total width
            const resetWidth = totalWidth / 2;

            // If calculated width is zero or container is not wide enough for scrolling, stop.
            if (resetWidth <= 0 || resetWidth <= marqueeContainer.offsetWidth) {
                // console.warn("Marquee content is not wide enough to scroll or width calculation failed.");
                // Optionally remove clones if not scrolling
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
                return;
            }

            // Calculate duration
            const duration = (speed > 0) ? (resetWidth / speed) * 1000 : 0; // in ms

            // Cancel any previous animation on the wrapper
            if (marqueeWrapper.animation) {
                marqueeWrapper.animation.cancel();
            }

            // --- Create Animation using WAAPI ---
            if (duration > 0) {
                const animation = marqueeWrapper.animate(
                    [
                        { transform: `translateX(25px)` },
                        { transform: `translateX(${direction * resetWidth}px)` }
                    ],
                    {
                        duration: duration,
                        iterations: Infinity,
                        easing: 'linear'
                    }
                );

                // Store the animation object
                marqueeWrapper.animation = animation;

                // --- Handle Pause/Play on Hover ---
                if (pauseOnHover) {
                    // Use variables to store bound functions for easy removal later if needed
                    const pauseAnimation = () => marqueeWrapper.animation?.pause();
                    const playAnimation = () => marqueeWrapper.animation?.play();

                    marqueeContainer.addEventListener('mouseenter', pauseAnimation);
                    marqueeContainer.addEventListener('mouseleave', playAnimation);

                    // Optional: Store listeners for potential cleanup
                    marqueeContainer.animationListeners = { pauseAnimation, playAnimation };
                }
            } else {
                // If duration is 0, ensure clones are removed if they were added
                while (marqueeWrapper.children.length > originalItems.length) {
                    marqueeWrapper.removeChild(marqueeWrapper.lastChild);
                }
            }
        }); // End of requestAnimationFrame

    });

})(jQuery)

    ; (() => {
        'use strict'

        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        const forms = document.querySelectorAll('.needs-validation')

        // Loop over them and prevent submission
        Array.from(forms).forEach(form => {
            form.addEventListener('submit', event => {
                if (!form.checkValidity()) {
                    event.preventDefault()
                    event.stopPropagation()
                }

                form.classList.add('was-validated')
            }, false)
        })
    })()